export enum NotificationPath {
    CLIENT_CHANGE_NOTIFICATION = "client_notification"
}
